import React, { useEffect, useState } from 'react';
import { ChevronsUpDown } from 'lucide-react';
import { TradeMode } from '@shared/types/frontend/trade';
import { CovalentBalanceItem } from '@shared/types/frontend';
import { Button } from '@/components/ui/button';
import TokenImage from '../../../shared/TokenImage';
import { getNetworkLogo, getTokenImageFromAssetItem } from '@/lib/misc/tokenImageHelper';
interface Props {
  tradeMode: TradeMode;
  asset: CovalentBalanceItem;
  showSelectionsModal: () => void;
}
const BuySellAssetSelection = (p: Props) => {
  const [cantBuy, setCantBuy] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!p.asset) {
        setCantBuy(true);
      }
    }, 5000);
    return () => clearTimeout(timer);
  }, [p.asset]);
  return <Button type='button' variant='ghost' className='w-fit self-center flex items-center gap-2 border border-genius-blue rounded-full px-3' onClick={() => {
    p.asset && p.showSelectionsModal();
  }} data-sentry-element="Button" data-sentry-component="BuySellAssetSelection" data-sentry-source-file="BuySellAssetSelection.tsx">
      {p.asset ? <>
          <TokenImage mainImageSrc={getTokenImageFromAssetItem(p.asset)} badgeImageSrc={getNetworkLogo(p.asset.network)} badgeSize={16} size={24} />
          <div className='opacity-50'>{p.tradeMode === TradeMode.BUY ? 'Using:' : 'To:'}</div>
          <div className='text-[16px]'>
            {p.asset?.contract_ticker_symbol ?? p.asset?.contract_name}
          </div>
          <ChevronsUpDown className='w-[16px]' />
        </> : cantBuy ? <div>You can only swap into this asset</div> : <div>Loading...</div>}
    </Button>;
};
export default BuySellAssetSelection;